import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";

import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";



function Cex() {


  return (
    <div className="newpage blog_page DEX_SR">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <div className="paddin_immner">
        <main className="carer_page">
          <span>
            <Helmet>
              <title>
                Decentralized Exchange Development | Decentralized Exchange
                Script | DEX Script| Beleaf technology
              </title>
              <meta name="robots" content="index"></meta>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/decentralized-cryptocurrency-exchange-development"
              />
              <meta
                name="title"
                content="Decentralized Exchange Development | Decentralized Exchange
                Script | DEX Script| Beleaf technology

                "
              />
              <meta
                name="description"
                content="looking for a reliable decentralized exchange development company? Discover our expert team's cutting-edge solutions and tailor-made services to build your decentralized exchange platform. Leverage the power of blockchain technology and seamless transactions with our trusted development services. Contact us today for a decentralized exchange that meets your specific business requirements.Get the best decentralized exchange script for a low price from the premier decentralized exchange development business. With our assistance, you may launch your decentralized exchange website with high security features and functions.
                "
              />
              <meta
                name="keywords"
                content="decentralized exchange development, decentralized exchange software, decentralized cryptocurrency exchange development company, decentralized exchange development company, decentralized crypto exchange software, top decentralized crypto exchanges, decentralized exchange script, decentralized cryptocurrency exchange script, dex script"
              />
              <meta
                property="og:title"
                content="Decentralized Exchange Development | Decentralized Exchange
                Script | DEX Script| Beleaf technology"
              />
              <meta property="og:site_name" content="Beleaf Technologies" />
              <meta
                property="og:url"
                content="https://beleaftechnologies.com/decentralized-cryptocurrency-exchange-development"
              />
              <meta
                property="og:description"
                content="looking for a reliable decentralized exchange development company? Discover our expert team's cutting-edge solutions and tailor-made services to build your decentralized exchange platform. Leverage the power of blockchain technology and seamless transactions with our trusted development services. Contact us today for a decentralized exchange that meets your specific business requirements.Get the best decentralized exchange script for a low price from the premier decentralized exchange development business. With our assistance, you may launch your decentralized exchange website with high security features and functions."
              />
              <meta property="og:type" content="website" />

              <meta name="twitter:card" content="summary" />
              <meta name="twitter:site" content="@BeleafTech" />
              <meta
                name="twitter:title"
                content="Decentralized Exchange Development | Decentralized Exchange
                Script | DEX Script| Beleaf technology"
              />
              <meta
                name="twitter:description"
                content="looking for a reliable decentralized exchange development company? Discover our expert team's cutting-edge solutions and tailor-made services to build your decentralized exchange platform. Leverage the power of blockchain technology and seamless transactions with our trusted development services. Contact us today for a decentralized exchange that meets your specific business requirements.Get the best decentralized exchange script for a low price from the premier decentralized exchange development business. With our assistance, you may launch your decentralized exchange website with high security features and functions."
              />

              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>
            <div className="ourserveic_banner dexex-img">
              <div className="bg-overlay"></div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-10">
                    <div className="service_content service_content_dex">
                      <h1>Decentralized exchange development</h1>
                      <p>
                        Unlock the entire potential of blockchain for your
                        business by using robust decentralized exchange
                        development from seasoned blockchain specialists!
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Start DEX now"
                      >
                        Start DEX now
                      </Button>
                    </div>
                
                  </div>
                </div>
              </div>
            </div>
            <section className="section bg-light decentral_img">
              <div className="container">
                <div className="row">
                  <div className="col-lg-9 col-md-12">
                    <div className="first_section_crypto">
                      <h2 className="text-center">
                        Decentralized Exchange Platform Development Company
                      </h2>
                      <p className="">
                        Decentralization eliminates the need for bureaucratic
                        hierarchy and provides a working paradigm without
                        middlemen. Most cryptocurrency exchanges are
                        decentralized, with trade pairings automatically mapped
                        to each other from the liquidity pool. A DEX crypto
                        platform allows traders to conduct peer-to-peer
                        transactions and is backed up by secure smart contracts.
                        <br />
                        We provide several white-label decentralized exchange
                        development options that include various
                        enterprise-grade features and are powered by powerful
                        trading engines. Our white-label DEX systems are
                        pre-built to assist cryptopreneurs in building the
                        exchange platform in the lowest amount of time. You may
                        come to us with your criteria and specifications for
                        establishing your crypto exchange, and our staff will
                        study them, extract feasible ones, and construct your
                        crypto trading platform.
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        Request A Proposal
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white ourdexexchange">
              <div className="container">
                <div className="col-lg-12">
                  <h2>Our Decentralized Exchange Development Services</h2>
                  <div className="row">
                    <div className="col-md-6 col-lg-4">
                      <div className="card_dex">
                        <img
                          src={require("../../image/DEX/buildscrach.webp")}
                          alt="techstack"
                        />
                        <div>
                          <h4>Building of DEX software from scratch</h4>
                          <p>
                            We assist you in developing a decentralized exchange
                            platform from the ground up, utilizing cutting-edge
                            technology tools and skilled developers and
                            designers.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="card_dex">
                        <img
                          src={require("../../image/DEX/bookmarks.webp")}
                          alt="techstack"
                        />
                        <div>
                          <h4>
                            White-Label Decentralized Crypto Exchange Software
                          </h4>
                          <p>
                            We create an immediate white-label DEX platform for
                            your crypto enterprise. Our DEX software is
                            customizable, and you may change it to meet your
                            company's requirements.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="card_dex">
                        <img
                          src={require("../../image/DEX/decentralized.webp")}
                          alt="techstack"
                        />
                        <div>
                          <h4>Decentralized Crypto Exchange Script</h4>
                          <p>
                            We provide ready-made decentralized crypto exchange
                            scripts from well-known DEX exchanges to help you
                            quickly launch your P2P platform.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="card_dex">
                        <img
                          src={require("../../image/DEX/p2p.webp")}
                          alt="techstack"
                        />
                        <div>
                          <h4>Creation of P2P Smart contract</h4>
                          <p>
                            We develop peer-to-peer (P2P) smart contracts that
                            enable trading without the use of middlemen,
                            resulting in increased speed and transparency of the
                            decentralized exchange.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="card_dex">
                        <img
                          src={require("../../image/DEX/technology.webp")}
                          alt="techstack"
                        />
                        <div>
                          <h4>Decentralized Exchange Integration</h4>
                          <p>
                            Our specialized decentralized exchange integration
                            services are focused on integrating distributed
                            ledger technology into existing corporate processes
                            to maximize its benefits.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                      <div className="card_dex">
                        <img
                          src={require("../../image/DEX/customer-service.webp")}
                          alt="techstack"
                        />
                        <div>
                          <h4>Other DEX Services</h4>
                          <p>
                            If you have a centralized exchange platform, we are
                            pleased to integrate our DEX software, offering
                            hybrid exchange development services.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 first_section_crypto">
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label="Request A Free Demo"
                        className="m-auto mt-4 margin_top_p"
                      >
                        Request A Free Demo
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2>
                        Salient Features of <br />
                        our DEX Software Services
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete grid_ful_height_tab">
                      <div className="row">
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item feure_img">
                            <img
                              src={require("../../image/DEX/menu.webp")}
                              alt="techstack"
                            />
                            <h4>Awesome Dashboard</h4>
                            <p>
                              You may routinely refresh yourself and keep an eye
                              on the activities using an amazing and
                              sophisticated dashboard.
                            </p>
                          </div>
                        </div>
                        <div className=" col-md-6 col-lg-4">
                          <div className="feure_item feure_img">
                            <img
                              src={require("../../image/DEX/transaction.webp")}
                              alt="techstack"
                            />
                            <h4>Transaction list</h4>
                            <p>
                              Your user may see all of the previous transactions
                              that were carried out with the use of blockchain
                              technology.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item feure_img">
                            <img
                              src={require("../../image/DEX/password.webp")}
                              alt="techstack"
                            />
                            <h4>Two-Factor Authentication</h4>
                            <p>
                              Our platform includes two-factor authentication as
                              well as a wallet for maximum security. This
                              guarantees that trading is safe.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item feure_img">
                            <img
                              src={require("../../image/DEX/payment.webp")}
                              alt="techstack"
                            />
                            <h4>Payment Gateway Support</h4>
                            <p>
                              Different payment gateways are supported by our
                              decentralised crypto exchange platform. It
                              incorporates adaptable payment innovations.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item feure_img">
                            <img
                              src={require("../../image/DEX/smart-contracts.webp")}
                              alt="techstack"
                            />
                            <h4>Smart Contract Integration</h4>
                            <p>
                              Smart contracts are built into our decentralised
                              exchange platform for immutability and automation.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                          <div className="feure_item feure_img">
                            <img
                              src={require("../../image/DEX/notification.webp")}
                              alt="techstack"
                            />
                            <h4>Push-up Notification</h4>
                            <p>
                              Users are alerted in real-time about exchange
                              activities and trade. The notification also keeps
                              your user up to date in real-time.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section pt-0 CTA_section mb-0 dex_CTA">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="card_CTA">
                      <div className="row">
                        <div className="col-lg-8">
                          <div className="content_section_CTA">
                            <h5>
                              Do You Have any Software Ideas in Your Mind? ,
                              Let’s Have A Conversation
                            </h5>

                            <Button
                              data-toggle="modal"
                              data-target="#myModal"
                              aria-label="Book A Call Now"
                            >
                              Book A Call Now
                            </Button>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="men">
                            <img
                              src={require("../../image/ai/office_men.webp")}
                              alt="CTA"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white DEX_site">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="dex_third_conetnt">
                      <h2>
                        Our novel decentralized exchange
                        <br />
                        development features
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="futerr_conete new_our_furtur inner_col_direction_column grid_ful_height_tab">
                      <div className="row">
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/DEX/swap-horizontal-orientation-arrows.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Atomic Swap</h4>
                              <p>
                                Atomic swap technology will be included with our
                                decentralized crypto exchange that helps to swap
                                one to another crypto without any intermediary.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/DEX/stock-market.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Instant response to complex trades</h4>
                              <p>
                                Our decentralized exchange platform has the
                                capability to facilitate and support complex
                                trades without any errors.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/DEX/checklist.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Decentralized Order Book</h4>
                              <p>
                                Our DEX platform utilises the distributed hash
                                table (DHT) system, which compiles the order
                                book automatically, and retrieves sell/buy
                                orders.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/DEX/cost.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div className="empty_dexdiv">
                              <h4>Nominal Cost Structure</h4>
                              <p>
                                Our DEX offers the most affordable pricing plan
                                and the most effective transaction fee rates in
                                the present crypto market.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/DEX/protection.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Safe Escrow System</h4>
                              <p>
                                Our decentralised cryptocurrency exchange
                                platform uses safe escrow management and
                                completes transactions quickly.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <div className="feure_item">
                            <div className="imag_card_section card_pic">
                              <img
                                src={require("../../image/DEX/website-design.webp")}
                                alt="techstack"
                              />
                            </div>
                            <div>
                              <h4>Personalizable Interface</h4>
                              <p>
                                Our DEX platform is highly customizable and
                                flexible to fit any business model respective to
                                the size and permits easy setup, and operations.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="CTA_singa">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="conatct_btin">
                      {/* <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto mt-4 margin_top_p button_link_sane"
                      >
                        Get Quote
                      </Button> */}
                      <a
                        href="https://wa.me/7904323274"
                        target="_blank"
                        className="button_link_sane"
                      >
                        Connect With Whatsapp
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="text_poit_ee">
                      <h2>
                        Key Benefits of our
                        <br /> Decentralized Crypto Exchange Software
                      </h2>
                      <p>
                        It is a platform with no central authority. As a
                        decentralized network, it provides excellent protection
                        against external pressures.
                      </p>
                      <ul>
                        <li>
                          <span>01</span>No interference from third parties
                        </li>
                        <li>
                          <span>02</span>No central server mechanism
                        </li>
                        <li>
                          <span>03</span>Privacy
                        </li>
                        <li>
                          <span>04</span>High Scalability
                        </li>
                        <li>
                          <span>05</span>Faster Transactions
                        </li>
                        <li>
                          <span>06</span>Highly Secure Platform
                        </li>
                        <li>
                          <span>07</span>Lower Transaction Fees
                        </li>
                        <li>
                          <span>08</span>Enhanced Security
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="key_benifit">
                      <img
                        src={require("../../image/DEX/benifit.webp")}
                        alt="techstack"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section pb-0">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="contact_CTA">
                      <h2>
                        Let's Talk About Your Project And Make Something
                        <br />
                        Outstanding, Start Conversation
                      </h2>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Book a Call"
                        className="m-auto mt-4"
                      >
                        Book a Call
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="call_mimga">
                      <img
                        src={require("../../image/DEX/contact.webp")}
                        alt="techstack"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white p-0">
              <div className="contaniner">
                <div className="development_process">
                  <img
                    src={require("../../image/DEX/DEX_process.webp")}
                    alt="techstack"
                  />
                </div>
              </div>
            </section>
            <section className="section">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="matic_content">
                      <h2>Technological Stack</h2>
                      <p>
                        We use a cutting-edge technical stack in the
                        decentralized exchange-building process to provide you
                        with a top-tier digital solution. Our usage of the
                        tried-and-true tech stack paradigm saves you time and
                        money in significant ways.
                      </p>
                      <a href="tel:+91 80567 86622" target="_blank">
                        Grab A Call{" "}
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <img
                      src={require("../../image/decentralized/texkstack.webp")}
                      alt="techstack"
                      className="matic_img"
                    />
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="matic_content p-0">
                      <h2 className="text-center">
                        What makes Beleaf technology an excellent choice for
                        Decentralized Exchange Software Development Services?
                      </h2>
                      <p className="text-center">
                        We are a team of blockchain and defi development
                        professionals with extensive expertise in providing
                        superior decentralised finance and other decentralised
                        exchange development solutions to our clients. We have
                        successfully completed over 50 projects relating to
                        decentralised crypto exchange software. Our developers
                        have expert-level expertise and experience in developing
                        decentralised exchange development solutions.
                        <br />
                        Beleaf Technology offers entirely customized white-label
                        DEX software solutions, allowing you to change your
                        options according to your company's needs. We provide
                        dex scripts of the largest decentralised crypto exchange
                        platforms on time, allowing you to jumpstart your
                        company right away. We provide client service around the
                        clock. Start a decentralised peer-to-peer cryptocurrency
                        exchange platform with us and become a successful
                        cryptopreneur.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="development_process img_center_Ee">
                      <img
                        src={require("../../image/DEX/why_work.webp")}
                        alt="techstack"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section CTA_singa">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="book_call_section">
                      <h2 className="text-center">
                        Dive into the surging decentralised sector by developing
                        your own DEX platform, Launch Your DEX Now
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="conatct_btin padin_btmn">
                      {/* <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        className="m-auto mt-4 margin_top_p button_link_sane"
                      >
                        Get Quote
                      </Button> */}
                      <a
                        href="https://wa.me/7904323274"
                        target="_blank"
                        className="button_link_sane"
                      >
                        Connect With Whatsapp
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What is a Decentralized Exchange Platform?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    DEX is an abbreviation for a Decentralized
                                    exchange platform. It enables traders to
                                    execute peer-to-peer crypto exchanges
                                    without any regulatory or legal barriers,
                                    resulting in faster and more efficient
                                    transactions.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    Is it possible to develop my DEX platform
                                    from Scratch?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Yes, of course. However, if you rely on a
                                    white-label crypto exchange or a dex script,
                                    your investment will be far lower and
                                    sufficient as compared to building a dex
                                    platform from scratch.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    Do you support my decentralised exchange
                                    platform with a crypto wallet and payment?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Yes, upon request, we provide crypto wallet
                                    and payment gateway integration services to
                                    our clients. Our extendable features cover
                                    such services as add-ons for our clients
                                    looking for decentralized crypto exchange
                                    software.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    How long it will take to develop a DEX
                                    platform?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    It varies depending on the requirements of
                                    your dex platform. Our offerings include
                                    decentralized cryptocurrency exchange from
                                    the ground up, a dex script-based platform,
                                    and white-label cryptocurrency exchange
                                    software.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    What will be the cost of developing a DEX
                                    platform?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    It varies according to the nature of your
                                    DEX services. The cost of developing a
                                    decentralized exchange programme from
                                    scratch would differ from the cost of
                                    developing a DEX script software. We make
                                    certain that we provide inexpensive DEX
                                    services for all startups and entrepreneurs
                                    looking to get their crypto firm off to a
                                    good start.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead6">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq6"
                                    aria-expanded="true"
                                    aria-controls="faq6"
                                  >
                                    What are the benefits of the Decentralized
                                    Exchange?
                                  </a>
                                </div>

                                <div
                                  id="faq6"
                                  className="collapse"
                                  aria-labelledby="faqhead6"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    DEX offers a enormous benefits as they are
                                    not prone to any hacking attacks, have a low
                                    risk of price manipulation, are not affected
                                    by local or international regulations, and
                                    enable easy creation of new orders without
                                    paying a high amount of fees.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
